/* unplugin-vue-components disabled */import { render } from "./collapse-group.vue?vue&type=template&id=fff771e2&scoped=true"
import script from "./collapse-group.vue?vue&type=script&lang=js"
export * from "./collapse-group.vue?vue&type=script&lang=js"

import "./collapse-group.vue?vue&type=style&index=0&id=fff771e2&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fff771e2"],['__file',"src/controls/collapse-group.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fff771e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fff771e2', __exports__)) {
    api.reload('fff771e2', __exports__)
  }
  
  module.hot.accept("./collapse-group.vue?vue&type=template&id=fff771e2&scoped=true", () => {
    api.rerender('fff771e2', render)
  })

}


export default __exports__